import { ReportEntity } from "src/pages/report/shared/components/Export";
import { ORDINATION_TYPES, OrdinationProps } from "../../../shared/types/Ordination"
import glotaTranslationService from "src/services/glota-translation.service";

export interface TableProps {
  records?: ReportEntity[];
  loading?: boolean;
}

export interface OrderTable {
  id: string;
  title: string
  text?: string
}

export const DEFAULT_ORDINATION_CONFIG: OrdinationProps = {
  order_by: 'request_date',
  order: ORDINATION_TYPES.DESCENDING
};

export const getOrdersTableTooltip = (): OrderTable[] => {
  return [
    { id: 'id_report', title: glotaTranslationService.translateSync('spa.report.identifier') },
    { id: 'title', title: glotaTranslationService.translateSync('spa.report.reportTitle') },
    { id: 'user_name', title: glotaTranslationService.translateSync('spa.report.requester'), text: glotaTranslationService.translateSync('spa.report.requesterDescription')},
    { id: 'created_at', title: glotaTranslationService.translateSync('spa.report.requestDate') },
    { id: 'expiration', title: glotaTranslationService.translateSync('spa.report.expirationDate'), text: glotaTranslationService.translateSync('spa.report.expirationDateDescription') },
    { id: 'size_export', title: glotaTranslationService.translateSync('spa.report.size'), text: glotaTranslationService.translateSync('spa.report.sizeDescription') },
    { id: 'status_export', title: glotaTranslationService.translateSync('spa.report.status') },
    { id: 'actions_export', title: glotaTranslationService.translateSync('spa.report.actions') },
  ];
};

// Mantém compatibilidade com código existente - usar getOrdersTableTooltip() em componentes React
export const ORDERS_TABLE_TOOLTIP: OrderTable[] = getOrdersTableTooltip();
